import * as withOutstandingDebtActions from '../actions/outstanding-debt';
import { OutstandingDebt } from '../models/outstanding-debt';

export interface State {
  outstandingDebt: OutstandingDebt;
  loading: boolean;
  error: string;
}

export const INITIAL_STATE: State = {
  outstandingDebt: undefined,
  loading: false,
  error: ''
}

export function reducer(state: State = INITIAL_STATE, action: withOutstandingDebtActions.Actions) {
  var errorMessage: string;

  switch (action.type) {
    case withOutstandingDebtActions.GET:
      {
        return {
          ...state,
          error: '',
          loading: true
        };
      }
    case withOutstandingDebtActions.GET_COMPLETE:
      {
        return {
          ...state,
          error: '',
          loading: false,
          outstandingDebt: action.payload
        };
      }
    case withOutstandingDebtActions.GET_ERROR:
      {
        errorMessage = '';
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }

        return {
          ...state,
          error: errorMessage,
          loading: false,
          outstandingDebt: undefined
        };

      }
    default:
      {
        return state;
      }

  }
}

